var jQuery = $;
import marquee from '../../node_modules/jquery.marquee/jquery.marquee.min.js';
import swiper from '../../node_modules/swiper/swiper-bundle.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';

const app = {
    /** Initialize */
    init() {

        // Init swiper
        this.initSwiperSliders();

        // listen for orientationchange event
        window.addEventListener('orientationchange', () => {
            // destroy existing swiper instances
            this.initSwiperSliders.destroy(true, true);

            // reinitialize swiper instances
            this.initSwiperSliders();
        });

        this.initializePopups();

        // Fade sections in on scroll
        // this.fadeInOnScroll();

        // Toggle FAQ accordion
        this.toggleFaqItems();

        // Init tabs
        this.initTabs();

        this.locationAlignment();

        // Custom play button
        this.customPlaybutton();

        // Smooth anchor
        this.smoothAnchor();

        // Trigger DataLayers for FAQ's
        this.triggerFaqDataLayers();

        // this.removeAndShowNavigationOnScroll();

        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger').on('click', $.proxy(this.toggleHamburgerMenu, this));
        $(".contact-button, .close-contact-popup, .close-button, a[href^='#faq']").on('click', $.proxy(this.toggleContactoptions, this));

        // Define marquee
        if ($(window).width() < 768) {
            $('.marquee').marquee({
                duplicated: true,
                // gap: 20,
                startVisible: true,
                duration: 24000,
            });

        }
    },

    /** Handles the scroll event */
    windowScrollHandler() {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 0);
    },

    /** Open hamburger menu */
    toggleHamburgerMenu() {
        $("header").toggleClass('open');
        $(".hamburger").toggleClass('active');
        $("nav.navigation").toggleClass('visible');
        // $(".navigation-bg").toggleClass('active');
        $("body").toggleClass('lock');
    },

    toggleContactoptions() {

        if (!($('.contact-popup').hasClass('opened'))) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'openContactPopup',
            });
        } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'closeContactPopup',
            });
        }

        $(".contact-popup").toggleClass('opened');
        $("body").toggleClass('is-locked');
    },

    initSwiperSliders() {
        if ($(window).width() < 1024) {
            const swiperReviewsAndTeamslider = new Swiper('.review-videos-slider, .team-slider', {
                spaceBetween: 25,
                slidesPerView: 1.2,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 25,
                    },
                }
            });
        }

        const swiperReviewsslider = new Swiper('.reviews-wrapper', {
            slidesPerView: 1.3,
            loop: true,
            spaceBetween: 25,
            grabCursor: true,
            breakpoints: {
                480: {
                    slidesPerView: 1.1,
                },
                768: {
                    slidesPerView: 1.4,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1280: {
                    slidesPerView: 2.4,
                    spaceBetween: 30,
                }
            },
        });
    },

    initializePopups() {
        $('a[href^="#reservation"]').on('click', function (e) {

            e.preventDefault();
            $.fancybox.open({
                src: '#reservation',
                touch: false,
                smallBtn: false,
                clickSlide: false,
                openEffect: 'none',
                closeEffect: 'none',
                clickOutside: 'close',
                afterClose: function () {
                    $('body').removeClass('is-locked');
                }
            });

            // Check which location needs to be opened
            let url = $(this).attr('href');
            let forValue = url.substring(url.indexOf('?') + 1).split('=')[1];

            if (forValue.length) {
                $('.location-popup .tabs .tabs-heading .tab').each(function () {
                    $(this).removeClass('active');

                    if ($(this).attr('data-heading-for') == forValue) {
                        $(this).addClass('active');
                    }
                });

                $('.location-popup .tabs .tab-content .tab-item').each(function () {
                    $(this).removeClass('active');

                    if ($(this).attr('data-content-for') == forValue) {
                        $(this).addClass('active');
                    }
                });
            }
        });

        $('.close-popup').click(function () {
            $.fancybox.close();
        });
    },

    locationAlignment() {
        var list = document.querySelector(".section-locations");

        if (!list) {
            return;
        }

        var locations = list.querySelectorAll(".location");
        var numItems = locations.length;

        if (numItems < 3) {
            list.classList.add("center");
        }
    },

    customPlaybutton() {
        $('.review-video').parent().click(function () {
            if ($(this).children(".review-video").get(0).paused) {
                $(this).children(".review-video").get(0).play();
                $(this).children(".custom-play").fadeOut();
                $(this).find(".play-text").removeClass("visible").addClass("hidden");
            }
            else {
                $(this).children(".review-video").get(0).pause();
                $(this).children(".custom-play").fadeIn();
                $(this).find(".play-text").removeClass("hidden").addClass("visible");
            }
        });
    },

    /** Open FAQ accordion */
    toggleFaqItems() {
        $(".toggle-heading").on("click", function () {
            if ($(this).parent().find(".toggle-content").hasClass("hidden")) {
                $(this).parent().find(".toggle-content.hidden").slideDown(500);
                $(this).parent().find(".toggle-content.hidden").removeClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("down")
                    .addClass("up");
            }
            else {
                $(this).parent().find(".toggle-content").slideUp(500);
                $(this).parent().find(".toggle-content").addClass("hidden");
                $(this)
                    .find(".arrow-wrapper")
                    .removeClass("up")
                    .addClass("down");
            }
        });
    },

    initTabs() {
        $(document).on('click', '.tab', function (e) {
            e.preventDefault();

            if (!$(this).hasClass('active')) {
                $('.tab.active').removeClass('active');
                $(this).addClass('active');

                let id = $(this).attr('href');

                $('.tab-item.active').removeClass('active');
                $('' + id + '').addClass('active');
            }
        });
    },

    // Smooth anchor
    smoothAnchor() {
        var $root = $('html, body');

        $('a[href^="#"]:not(.open-popup, .tab)').click(function (e) {
            if ($(this).attr('href') !== '#reservation' && $(this).attr('href') !== '#' && $(this).attr('href').indexOf('?') == -1) {

                e.preventDefault();
                $root.animate({
                    scrollTop: $($.attr(this, 'href')).offset().top + 25
                }, 500);

                return false;
            } else {
                e.preventDefault();
            }
        });
    },

    /** Fade sections in on scroll */
    // fadeInOnScroll() {
    //     $.fn.initFadeIn = function () {
    //         $('.section').each(function () {
    //             let top_of_element = $(this).offset().top + 150;
    //             let bottom_of_element = $(this).offset().top + $(this).outerHeight();
    //             let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
    //             let top_of_screen = $(window).scrollTop();
    //             if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element) && !$(this).hasClass('is-visible')) {
    //                 $(this).addClass('is-visible');
    //             }
    //         });
    //     };
    //     $.fn.initFadeIn();
    //     $(window).scroll(function () {
    //         $.fn.initFadeIn();
    //     });
    // },

    // removeAndShowNavigationOnScroll() {

    //     var lastScrollTopPosition;

    //     let header = document.getElementById('header');

    //     window.addEventListener('scroll', function () {
    //         let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //         if (scrollTop > lastScrollTopPosition) {
    //             if (window.innerWidth > 1024) {
    //                 header.style.top = '-80px';
    //             } else {
    //                 header.style.top = '-70px';
    //             }
    //         } else {
    //             header.style.top = '0';
    //         }

    //         lastScrollTopPosition = scrollTop;
    //     });
    // },

    triggerFaqDataLayers() {
        $('.faq-question').on('click', function () {
            if (!$(this).next().hasClass('hidden')) {

                // Send DataLayer only whe FAQ content is visible
                let faqQuestion = $(this).find('h3').html();
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'faq',
                    'vraag': faqQuestion,
                });
            }
        });
    },
};


$(document).ready($.proxy(app.init, app));
